import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./es.json";
import en from "./en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es }, en: { translation: en } },
    fallbackLng: "es",
    defaultNS: "translation",
    interpolation: { escapeValue: false },
    detection: {
      // Only check localStorage — if not set, default is Spanish (fallbackLng)
      // This prevents the browser language (en) from overriding the Spanish-first UX
      order: ["localStorage"],
      caches: ["localStorage"],
    },
  });

export default i18n;
